var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dispensation-check-form',{attrs:{"patientId":_vm.patientId,"dispensationId":_vm.dispensationId}})}
var staticRenderFns = []

export { render, staticRenderFns }